import styles from './TraumaAppendix.module.css';

/**
 * Statická příloha k Traumatologickému plánu (str. 2–26 / 26).
 *
 * PDF, které uživatel dodal, je sken (prakticky bez extrahovatelného textu),
 * takže pro věrné zobrazení tisk/PDF/email exportu renderujeme stránky jako obrázky.
 */
export function TraumaAppendix() {
  // BASE_URL je '/' v devu a '/v2/' v produkci — bez prefixu by se sken
  // v produkci (nasazené pod /v2/) nenačetl ani v náhledu, ani do PDF/e-mailu.
  const base = import.meta.env.BASE_URL;
  const pages = Array.from({ length: 25 }, (_, idx) => {
    const pageNumber = idx + 2; // 2..26
    const src = `${base}trauma-plan/trauma-${String(pageNumber).padStart(2, '0')}.png`;
    return { pageNumber, src };
  });

  return (
    <section className={styles.wrap} aria-label="Příloha — organizační směrnice">
      {pages.map((p) => (
        <article key={p.pageNumber} className={styles.page} aria-label={`Strana ${p.pageNumber} / 26`}>
          <img
            className={styles.pageImg}
            src={p.src}
            alt={`Plán první pomoci (traumatologický plán) — strana ${p.pageNumber} z 26`}
            loading="lazy"
          />
        </article>
      ))}
    </section>
  );
}

